module.exports = __webpack_public_path__ + "static/4-c5a4e99056892ce9cd50219684608222.jpeg";